import { FormControlLabel, Switch } from '@mui/material';

interface OnPremFieldProps {
  value: boolean;
  setValue: (value: boolean) => void;
}

function OnPremField({ value, setValue }: OnPremFieldProps): React.JSX.Element {
  return (
    <FormControlLabel
      control={<Switch checked={value} onChange={(_, v) => setValue(v)} />}
      label='On Prem'
    />
  );
}

export default OnPremField;

